module.exports = __webpack_public_path__ + "static/media/YF102_1.3541e262.jpg";